import stylesheet0 from "@oneappexchange/appx-font-utilities";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".disclaimer" + shadowSelector + " {padding-bottom: var(--sds-g-spacing-5);}.text-area" + shadowSelector + " {resize: none;transition: height 0.66s ease-out;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet];